import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import styles from "./App.module.css";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import MainPg from "./pages/mainPg/mainPg";
import CompanyPg from "./pages/companyPg/companyPg";
import BusinessPg from "./pages/businessPg/businessPg";
import EmployPg from "./pages/employPg/employPg";
import Client from "./pages/clientPg/clientPg";
import ComCeo from "./components/company/com_ceo/com_ceo";
import ComInfo from "./components/company/com_info/com_info";
import ComHistory from "./components/company/com_history/com_history";
import ComMember from "./components/company/com_member/com_member";
import ComMap from "./components/company/com_map/com_map";
import BusOutline from "./components/business/bus_outline/bus_outline";
import BusKind from "./components/business/bus_kind/bus_kind";
import BusProcess from "./components/business/bus_process/bus_process";
import EmpTalent from "./components/employ/emp_talent/emp_talent";
import EmpWelfare from "./components/employ/emp_welfare/emp_welfare";
import EmpRecruit from "./components/employ/emp_recruit/emp_recruit";
import EmpFaq from "./components/employ/emp_faq/emp_faq";
import LoadingPg from "./pages/loadingPg/loadingPg";
import UpBtn from "./components/main/upBtn/upBtn";
import CliClaim from "./components/client/cli_claim/cli_claim";
import CliClaimBoard from "./components/client/cli_claim_board/cli_claim_board";
import Private from "./components/private/private";
import IngPg from "./pages/ingPg/ingPg";

function App() {
  const [loadingOn, setLoadingOn] = useState(false);
  const [menuOn, setMenuOn] = useState(false);
  const [subMenuOn, setSubMenuOn] = useState(false);
  const [windowWidth, setWindowWidth] = useState(1160);
  const [positionY, setPositionY] = useState(0);
  const [bgImage, setbgImage] = useState("");

  const onScroll = () => {
    setPositionY(window.scrollY);
  };

  const onResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    setPositionY(window.scrollY);
    setSubMenuOn(false);
    setLoadingOn(true);
    setInterval(() => {
      setLoadingOn(false);
    }, 1000);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return <IngPg />;
  // return loadingOn ? (
  //   <LoadingPg />
  // ) : (
  //   <div className={styles.app}>
  //     <div className={styles.bgImage_cont} style={{ height: bgImage[1] }}>
  //       <img
  //         className={styles.bgImage}
  //         src={bgImage}
  //         alt="배경 이미지"
  //         loading="lazy"
  //         width="1920px"
  //         height="auto"
  //         decoding="async"
  //       />
  //     </div>
  //     <div
  //       className={
  //         positionY > 0 || subMenuOn || menuOn
  //           ? styles.header_on
  //           : styles.header_off
  //       }
  //     >
  //       <Header
  //         menuOn={menuOn}
  //         setMenuOn={setMenuOn}
  //         subMenuOn={subMenuOn}
  //         setSubMenuOn={setSubMenuOn}
  //         windowWidth={windowWidth}
  //         positionY={positionY}
  //       />
  //     </div>
  //     <div className={positionY > 0 ? styles.upBtn_cont : styles.gone}>
  //       <UpBtn positionY={positionY} />
  //     </div>
  //     <div className={styles.app_cont}>
  //       <Routes>
  //         <Route
  //           path=""
  //           element={
  //             <MainPg setbgImage={setbgImage} windowWidth={windowWidth} />
  //           }
  //         ></Route>
  //         <Route path="company" element={<CompanyPg setbgImage={setbgImage} />}>
  //           <Route path="ceo" element={<ComCeo />} />
  //           <Route path="info" element={<ComInfo />} />
  //           <Route path="history" element={<ComHistory />} />
  //           <Route path="member" element={<ComMember />} />
  //           <Route path="map" element={<ComMap />} />
  //         </Route>
  //         <Route
  //           path="business"
  //           element={<BusinessPg setbgImage={setbgImage} />}
  //         >
  //           <Route path="outline" element={<BusOutline />} />
  //           <Route path="kind" element={<BusKind />} />
  //           <Route path="process" element={<BusProcess />} />
  //         </Route>
  //         <Route path="employ" element={<EmployPg setbgImage={setbgImage} />}>
  //           <Route path="talent" element={<EmpTalent />} />
  //           <Route path="welfare" element={<EmpWelfare />} />
  //           <Route path="recruit" element={<EmpRecruit />} />
  //           <Route path="faq" element={<EmpFaq />} />
  //         </Route>
  //         <Route path="client" element={<Client setbgImage={setbgImage} />}>
  //           <Route path="claim" element={<CliClaim />} />
  //           <Route path="claim_write" element={<CliClaimBoard />} />
  //           <Route path="claim_read" element={<CliClaimBoard />} />
  //           <Route path="private" element={<Private />} />
  //         </Route>
  //       </Routes>
  //     </div>
  //     <div className={styles.footer}>
  //       <Footer windowWidth={windowWidth} />
  //     </div>
  //   </div>
  // );
}

export default App;
